import { request, RequestError, RequestErrorType } from '@tencent/vft-common/request'
import mixin from '../mixin'
import login from '@tencent/vft-common/login'
import cookie from '@tencent/vft-common/cookie'
import env from '@tencent/vft-common/env'
import { getChannel } from '../util/channel'

const cgi = {
  takeMovieCgi: '//vip.video.qq.com/fcgi-bin/comm_cgi?name=TakeMovieCgiSvr&otype=json',
  giveMovieCgi: '//vip.video.qq.com/fcgi-bin/comm_cgi?name=GiveMovieCgiSvr&otype=json'
}

export async function checkTakeMovie () {
  return request(cgi.takeMovieCgi, {
    uin: login.isLogin() ? login.getUin() : 1, // 未登录时，传1 yuanzhu 要求
    giveUin: mixin.computed.giveuin,
    cid: mixin.computed.cid,
    taskid: mixin.computed.taskid,
    _t: 3,
    cmd: 3,
    low_login: 1,
    g_tk: login.getToken()
  }, {
    dataType: 'jsonp',
    xhrFields: {
      withCredentials: true
    }
  }).then(res => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR)
    }
    return res
  })
}

export async function takeMovie ({ vipid, nick, headurl }) {
  let plat = 0
  let channel = getChannel()
  if (env.isAndroid) {
    plat = 108
  } else if (env.isIphone) {
    plat = 107
  } else if (env.isIpad) {
    plat = 105
  }
  // let cgi = await initTest()
  return request(cgi.takeMovieCgi, {
    uin: vipid,
    giveUin: mixin.computed.giveuin,
    cid: mixin.computed.cid,
    taskid: mixin.computed.taskid,
    _t: 2,
    cmd: 2,
    openid: login.loginType() === 'wx' ? cookie.get('openid') : '',
    wxnick: nick,
    headimg: mixin.methods.normalize(headurl),
    low_login: 1,
    g_tk: login.getToken(),
    plat_give: plat,
    channel: channel
  }, {
    dataType: 'jsonp',
    xhrFields: {
      withCredentials: true
    }
  }).then(res => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR)
    }
    return res
  })
}

export async function checkGiveMovie () {
  // let cgi = await initTest()
  return request(cgi.giveMovieCgi, {
    uin: login.getUin(),
    _t: 6,
    cmd: 6,
    cid: mixin.computed.cid,
    g_tk: login.getToken(),
    low_login: 1
  }, {
    dataType: 'jsonp',
    xhrFields: {
      withCredentials: true
    }
  }).then(res => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR)
    }
    return res
  })
}

export async function giveMovie ({ vipid, nick, headurl, param }) {
  // let cgi = await initTest()
  return request(cgi.giveMovieCgi, {
    _t: 4,
    cmd: 4,
    uin: vipid,
    openid: '',
    wxnick: nick,
    headimg: headurl,
    cid: mixin.computed.cid,
    taskid: param.taskid,
    givestamp: param.stamp,
    low_login: 1,
    g_tk: login.getToken(),
    plat_give: param.plat,
    channel: param.channel
  }, {
    dataType: 'jsonp',
    xhrFields: {
      withCredentials: true
    }
  }).then(res => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR)
    }
    if (!res.result) {
      throw new RequestError(res.result.code, res.msg || '未知错误', res, RequestErrorType.LOGIC_ERR)
    }
    return res
  })
}

export function getCoverInfo (cid) {
  return request('//data.video.qq.com/fcgi-bin/data?tid=363&appid=20001059&appkey=c8094537f5337021&otype=json', {
    idlist: cid
  }, {
    dataType: 'jsonp',
    xhrFields: {
      withCredentials: true
    }
  }).then(res => {
    if (!res) {
      throw new RequestError(-2, '网络开了小差，请重试', res, RequestErrorType.SYSTEM_ERR)
    }
    if (res.errorno !== 0 || !res.results || !res.results.length || !res.results[0].fields) {
      throw new RequestError(res.errorno, res.msg || '未知错误', res, RequestErrorType.LOGIC_ERR)
    }
    return res.results[0].fields
  })
}
